import axios from 'axios';
import { IConsent } from '@xsolla/gdpr/dist/bundle';
import gtm from './gtm';

export interface GdprApp {
  show(): void;
}

export default class GdprBanner {
  private static gdprInstance?: GdprApp;

  static async createInstance(callback: (app: GdprApp) => void) {
    const gdpr = await import('@xsolla/gdpr/dist/bundle');
    const region = await this.getLocation();

    gdpr.onConsent((consent: IConsent, prev: IConsent) => {
      if (prev.cookie && consent.cookie && consent.gdpr) {
        if (
          prev.cookie.analytics_consent_state
          && !consent.cookie.analytics_consent_state
        ) {
          window.location.reload();
        }

        if (consent.cookie.analytics_consent_state) {
          gtm();
        }
      }
    });

    gdpr.initialize(
      {
        state: {
          productName: 'drops',
          customCookieUrl: 'https://x.la/privacy-policy',
        },
        localization: {
          locale: 'en-US',
        },
        settings: {
          useDataProcessing: this.checkEuropeanUnion(region),
        },
      },
      (err: unknown, app?: GdprApp) => {
        if (err || !app) {
          return;
        }

        this.gdprInstance = app;
        callback(app);
      },
    );
  }

  static async getLocation() {
    try {
      const response = await axios.get<{ region: string }>('https://xsolla.com/api/geo');

      return response.data.region;
    } catch (e) {
      return 'US';
    }
  }

  static getInstance() {
    return this.gdprInstance;
  }

  static checkEuropeanUnion(country: string): boolean {
    const euCountries = [
      'BE',
      'BG',
      'CZ',
      'DK',
      'DE',
      'EE',
      'IE',
      'EL',
      'ES',
      'FR',
      'HR',
      'IT',
      'CY',
      'LV',
      'LT',
      'LU',
      'HU',
      'MT',
      'NL',
      'AT',
      'PL',
      'PT',
      'RO',
      'SI',
      'SK',
      'FI',
      'SE',
      'UK',
    ];

    return euCountries.includes(country);
  }
}
